export default "__VITE_ASSET__C_6lrBWg__"